/**
 * Shared page spacing — keep headings/tabs/tables/buttons aligned
 * with modest inset from the sidebar (not flush, not sparse).
 */
export const PAGE_CONTENT_SX = {
  px: 2, // ~16px left (from sidebar) + right
  pt: 1.5,
  pb: 2,
  boxSizing: "border-box",
  width: "100%",
};

/** Outer bordered page container (Organization Utilities style). */
export const PAGE_SHELL_PAPER_SX = {
  width: "100%",
  minHeight: "calc(100vh - 110px)",
  display: "flex",
  flexDirection: "column",
};

/** Page title row inside the shell, above tabs/content. */
export const PAGE_SHELL_HEADER_SX = {
  px: 2,
  pt: 2,
};

/** Default padded body when a page has no tabs. */
export const PAGE_SHELL_BODY_SX = {
  p: 3,
};

/** Tab panels: no extra horizontal pad (page already insets). */
export const TAB_PANEL_SX = {
  px: 0,
  pt: 1.5,
  pb: 0,
};

/**
 * Page-level tab bar chrome — matches Manage Your Team / Patients:
 * bottom divider under TabList; same horizontal inset as page title.
 */
export const PAGE_TABS_BAR_SX = {
  borderBottom: 1,
  borderColor: "divider",
  mt: 0.5,
  px: 2,
  "& .MuiTab-root": {
    px: 0,
    mr: 2.5,
  },
};

/**
 * Shared TabList / Tabs colors — secondary text + indicator everywhere.
 * Spread onto TabList or MUI Tabs: `{...PAGE_TAB_LIST_PROPS}`.
 */
export const PAGE_TAB_LIST_PROPS = {
  textColor: "secondary",
  indicatorColor: "secondary",
};

/** Compact Add / primary action button above table search row */
export const TABLE_ADD_BUTTON_SX = {
  textTransform: "none",
  fontWeight: 600,
  px: 1.5,
  py: 0.35,
  minHeight: 32,
  fontSize: "0.8125rem",
};

/** Soft primary blue for toolbar / row action icons (white + blue theme) */
export const TABLE_ICON_SX = {
  color: "primary.main",
};

export const TABLE_ICON_BUTTON_SX = {
  color: "primary.main",
  p: 0.75,
  "&:hover": {
    bgcolor: "rgba(86, 138, 247, 0.08)",
  },
};

/** Add-button row above search — tight spacing */
export const TABLE_ACTIONS_ROW_SX = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  width: "100%",
  mb: 0.5,
  gap: 0.75,
};

/** Search + Filter + Export + Refresh on one row */
export const TABLE_SEARCH_ROW_SX = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  alignItems: { xs: "stretch", sm: "center" },
  gap: 0.75,
  width: "100%",
};

export default PAGE_CONTENT_SX;
